const tezauryPrefixPath = '/internal/tezaury';
const iamPrefixPath = process.env.REACT_APP_IAM_PREFIX_PATH;

export {
  tezauryPrefixPath, iamPrefixPath,
};
